<template>
  <b-card no-body class="mt-n2">
    <b-row class="mx-1 mt-2 mb-1">
      <b-card
        v-if="hasPackageSelection"
        class="header-card"
      >
        <h4 class="mb-1">Package Details</h4>
        <div class="details-row d-flex flex-row mt-2">
          <span>
            <b-icon :style="{ color: iconColors.blue }" class="mr-0-5" icon="info-square-fill"/>
            <b>Name:</b>
            {{ selectedPackage.packageName ? selectedPackage.packageName : 'N/A' }}
          </span>
          <span>
            <b-icon variant="success" class="mr-0-5" icon="tag-fill"/>
            <b>Publisher:</b>
            {{ packages.length && packages[0].publisher ? packages[0].publisher : 'N/A' }}
          </span>
        </div>
      </b-card>
      <h4 class="mb-1" v-else>No Package Selected</h4>
    </b-row>
    <b-row v-if="hasPackageSelection" class="ml-0-5 my-1">
      <b-col>
        <div v-if="hasData">
          <b-table
            class="table-with-actions-min-height px-2"
            responsive
            striped
            outlined
            :items="packagesFilter"
            :fields="computedTableFields"
            :per-page="perPage"
            :current-page="currentPage"
            :filter="filter"
            @filtered="onFiltered"
          >
            <template #cell(installedOn)="row">
              {{ formatDate(row.value) }}
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="paginationTotalRows"
            :per-page="perPage"
            align="right"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-2 mx-1"
          />
        </div>
        <div v-else-if="loaded" class="mx-1 pl-1 mb-1">
          {{ $t("No Data Available") }}
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import SecurityEventBus from '@/xvisor/bus/SecurityEventBus';
import colorPalette from '@/xvisor/constants/colorPalette';
import moment from 'moment';
import momentTimeFormat from '@/xvisor/constants/momentTimeFormat';

const ZERO_TIME_VALUE = '0001-01-01T00:00:00Z';

export default {
  props: {
    timeRange: {
      type: Object,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedPackage: null,
      packages: [],
      loaded: false,
      currentPage: 1,
      perPage: 10,
      options: [
        { value: 5, text: '5' },
        { value: 10, text: '10' },
        { value: 15, text: '15' },
      ],
      filter: null,
      filteredLength: null,
      tableFields: [
        { key: 'deviceName', label: 'Device', sortable: true },
        { key: 'osType', label: 'OS Type', sortable: true },
        { key: 'installedOn', label: 'Installed On', sortable: true },
        { key: 'version', label: 'Version', sortable: true },
      ],
      selected: [],
      iconColors: {
        blue: colorPalette.teal,
        purple: colorPalette.purple,
      },
    };
  },
  computed: {
    hasPackageSelection() {
      return this.selectedPackage !== null && this.selectedPackage !== undefined;
    },
    hasData() {
      return this.loaded && this.packages && this.packages.length > 0;
    },
    paginationTotalRows() {
      if (this.filter) return this.filteredLength;
      return this.packages.length;
    },
    computedTableFields() {
      return this.tableFields;
    },
    packagesFilter() {
      const retVal = this.packages;
      return retVal;
    },
  },
  watch: {
    timeRange() {
      this.selectedPackage = null;
    },
  },
  created() {
    SecurityEventBus.$on('update-selected-package', (curPackage) => {
      this.selectedPackage = curPackage;
      this.httpGet();
    });
  },
  methods: {
    httpGet() {
      const detailEndpoint = `/security/endpoint/${this.selectedPackage.packageName}/packagedetails.json`;

      this.loaded = false;
      this.$http
        .get(detailEndpoint, {
          params: {
            start: this.timeRange.start.toISOString(),
            end: this.timeRange.end.toISOString(),
          },
        })
        .then((response) => { this.packages = response.data; })
        .finally(() => { this.loaded = true; });
    },
    onFiltered(filteredItems) {
      this.filteredLength = filteredItems.length;
      this.currentPage = 1;
    },
    formatDate(dateStr) {
      if (dateStr === ZERO_TIME_VALUE) {
        return 'N/A';
      }
      return moment(dateStr).format(momentTimeFormat.dateYearTime);
    },
  },
};
</script>

<style scoped>
  .header-card {
    width: 100%;
  }
  .header-card>.card-body {
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  }
  .details-row {
    gap: 5rem;
  }
</style>
